import { Box, Heading, VStack } from "@chakra-ui/react";
import Link from "next/link";
import { urlUpdate } from "../../../support/functions";
import { wpStyles } from "../../../theme/wp-styles";

const FooterMenu = ({ title, items = [] }) => {
  if (!items || !items.length) {
    return <></>;
  }
  return (
    <VStack
      align="stretch"
      sx={{
        a: {
          display: "block",
          p: 2,
          textDecor: "none",
          fontSize: "var(--wp--preset--font-size--small)",
          color: wpStyles.colors["font-default"],
        },
      }}
    >
      {title && (
        <Heading as="h3" fontSize="var(--wp--preset--font-size--medium)">
          {title}
        </Heading>
      )}
      <VStack align="stretch">
        {items.map(({ url, label }, i) => (
          <Box key={i}>
            <Link href={urlUpdate(url)}>
              <a>{label}</a>
            </Link>
          </Box>
        ))}
      </VStack>
    </VStack>
  );
};

export default FooterMenu;
